import { IModuleManifest } from '../../types';

import routes from './routes';

export const CoreModule: IModuleManifest = {
    name: 'core',
    version: '1.0.0',
    description: 'Core Module',
    routes
};
